import React from 'react';
import { useTranslation } from 'react-i18next';
import { CookieBanner, cookieBannerLabels } from '@easydent/shared-ui';

/**
 * The shared cookie banner, in the language the rest of the app is using.
 *
 * `useSuspense: false` is deliberate. Translations load over HTTP here, and the banner renders
 * *outside* App's Suspense boundary — a suspending hook would throw rather than wait. With suspense
 * off, an early render simply falls back to the English defaults baked into the component and
 * re-renders once the namespace arrives.
 */
const AppCookieBanner: React.FC = () => {
  const { t } = useTranslation('common', { useSuspense: false });
  return <CookieBanner labels={cookieBannerLabels(t)} />;
};

export default AppCookieBanner;
